import { createStore, applyMiddleware, combineReducers, compose } from "redux";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Local storage
// import storageSession from "redux-persist/lib/storage/session";
import Users from "../reducers/Users";
import Header from "../reducers/Header";
import Footer from "../reducers/Footer";
import Content from "../reducers/Content";
import Utils from "../reducers/Utils";
import { returnCalculatorReducer } from "../reducers/ReturnCalculatorSlice";

const persistConfig = {
  key: "root",
  // storage: storageSession,
  storage,
  whitelist: ["user", "returnCalculator"], // Persist only user-related data
};

const rootReducer = combineReducers({
  user: Users,
  header: Header,
  footer: Footer,
  contents: Content,
  utils: Utils,
  returnCalculator: returnCalculatorReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(thunk))
);

const persistor = persistStore(store);

export default () => ({ store, persistor });
